import {PHASES} from '../../../constants/phases';
import {selectPhase} from '../../../redux/reducers/sharedStateReducer/selectors';
import {
  selectIsCityCaptureAnimationPlaying,
  selectIsRuinsIncomeAnimationAwaited,
} from '../../../redux/reducers/privateStateReducer/selectors';

/**
 * Показывать ли на поле снабжение: активные фермы с остатком снабжения
 * (calculateTokenImage), отметки снабжения на отрядах, маркеры выбранной
 * фермы, звук авто-раздачи.
 *
 * Пока идет облет захваченных городов (scenes/CityCaptureAnimation), новый
 * раунд в состоянии уже начался и снабжение могло раздаться автоматически, а
 * на поле еще конец войны. Снабжение показывается, когда облет кончился и
 * открылась модалка захвата. Рост дохода руин (scenes/RuinsIncomeAnimation) идет
 * после итогов раунда, и снабжение ждет и его — от самого перехода раунда
 * @param {Object} state
 * @returns {boolean}
 */
export const checkIfSupplyShownOnField = (state) => selectPhase(state) === PHASES.SUPPLY
  && !selectIsCityCaptureAnimationPlaying(state)
  && !selectIsRuinsIncomeAnimationAwaited(state);
